'use client';

import React from 'react';
import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';
import { StepOneConsultationProps } from '@/sections/forms/multistep-form/steps/ConsultationStep/types';

const ConsultationStep: React.FC<StepOneConsultationProps> = ({
  loading,
  consultations,
  selectedTitle,
  onSelect,
}) => {
  return (
    <div
      role="radiogroup"
      aria-label="Beratungsart"
      className="flex flex-col gap-4"
    >
      {loading ? (
        <div className="flex items-center justify-center py-6">
          <LoaderCircle
            className="h-8 w-8 animate-spin text-brand-700"
            aria-label="Loading"
          />
        </div>
      ) : (
        consultations.map((c) => {
          const selected = selectedTitle === c.title;

          return (
            <div
              key={c.id}
              role="radio"
              aria-checked={selected}
              aria-disabled={false}
              tabIndex={0}
              onClick={() => onSelect?.(c.title)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect?.(c.title);
                }
              }}
              className={clsx(
                'relative w-full min-w-0 rounded-xl border px-6 py-5 text-left transition-colors',
                'cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-500',
                selected
                  ? 'border-brand-700 bg-[#F6FBFF]'
                  : 'border-neutral-200 bg-white hover:border-brand-300',
              )}
            >
              {selected && (
                <input type="hidden" name="consultation" value={c.title} />
              )}

              <div className="flex min-w-0 flex-col gap-1">
                <span className="min-w-0 hyphens-auto break-words text-sm font-semibold text-slate-900">
                  {c.title}
                </span>

                {c.description ? (
                  <span className="min-w-0 hyphens-auto break-words text-sm text-slate-600">
                    {c.description}
                  </span>
                ) : null}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default ConsultationStep;
